import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { Priority } from '../../model/priority/types.tsx';
import {
	PRIORITY_SEARCH_API_ENDPOINT,
	ALL_PRIORITIES_DATA_OPERATION_NAME,
	ALL_PRIORITIES_QUERY,
} from './constants.tsx';
import type { FetchAllPrioritiesResponse } from './types.tsx';

export const transformer = (priorities: FetchAllPrioritiesResponse): Priority[] => {
	const allPriorities = priorities.data.jira.jiraProjects.map((project) =>
		project.priorityScheme.priorities.edges.map((edge) => ({
			id: edge.node.priorityId,
			name: edge.node.name,
			iconUrl: edge.node.iconUrl,
		})),
	);
	const intersectingPriorities = allPriorities.reduce((prioritiesA, prioritiesB) =>
		prioritiesA.filter((priorityA) =>
			prioritiesB.some((priorityB) => priorityA.id === priorityB.id),
		),
	);

	return intersectingPriorities;
};

export const fetchAllPriorities = (projectIds: string[]): ObservableType<Priority[]> =>
	fetchJson$<FetchAllPrioritiesResponse>(
		`${PRIORITY_SEARCH_API_ENDPOINT}?operation=${ALL_PRIORITIES_DATA_OPERATION_NAME}`,
		{
			method: 'post',
			body: JSON.stringify({
				query: ALL_PRIORITIES_QUERY,
				variables: {
					projectIds,
				},
			}),
		},
	).map(transformer);
